import {Component, NgZone, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "./workflow.service";
import {WorkflowStepStatus} from "./models/workflow-step-status.enum";

@Component({
  selector: "workflow-step-bar",
  templateUrl: "./workflow-step-bar.template.pug",
})

export class WorkflowStepBarComponent implements OnInit, OnDestroy {
  dropdownVisible: boolean = false;
  WorkflowStepStatus = WorkflowStepStatus;

  documentClickListener() {
    if (!this.dropdownVisible) return;

    this.zone.run(() => {
      this.dropdownVisible = false;
    });
  }

  ngOnInit() {
    document.addEventListener("click", this.documentClickListener.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener("click", this.documentClickListener.bind(this));
  }

  showDropdown(event: Event) {
    this.dropdownVisible = true;
    event.preventDefault();
    event.stopPropagation();
  }

  hideDropdown(event: Event) {
    this.dropdownVisible = false;
    event.preventDefault();
    event.stopPropagation();
  }

  preventDefault(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  constructor(
    public workflowService: WorkflowService,
    public route: ActivatedRoute,
    public router: Router,
    private zone: NgZone,
  ) {

  }
}
